import { h, render } from 'preact';
import smoothscroll from 'smoothscroll-polyfill';
import * as serviceWorker from './serviceWorker';
import 'normalize.css';
import './index.less';
import App from './app/pages/App';

window.onbeforeunload = () => {
  window.scrollTo(0, 0);
};

smoothscroll.polyfill();

render(<App />, document.getElementById('root'));

if (process.env.DISABLE_SW) {
  serviceWorker.unregister();
} else {
  serviceWorker.register();
}
